<section class="safetytrainingrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Safety Training</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-8" data-aos="fade-right" data-aos-delay="300">

                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            <strong>Through Training </strong> you give your employees the knowledge and tools to work safely.
                        </h3>

                        <p class="theme_color fontSize">
                            With more than 150 years of combined safety training experience, 
                            SFI Safety provides practical training designed to support regulatory requirements, 
                            strengthen safe work practices, and create lasting knowledge in the field. 
                            Our training is Built on Excellence, 
                            with qualified and authorized instructors delivering courses you can trust in both English and Spanish.
                        </p>
                        <p class="theme_color fontSize">
                            We stand behind the training we provide. If applicable regulations change within one year of the class date,
                             we will provide updated information
                             and, when necessary, help ensure required recertification is addressed.
                        </p>
                        <p>
                            Take your team Beyond Compliance with training Built on Excellence. Contact us today to schedule a class,
                             bring training directly to
                             your jobsite or office, or build a customized training program for your workforce.
                              Call 800-727-5051 or email <a href="customerservice@sfisafety.com.">customerservice@sfisafety.com.</a>
                        </p>

                        <h3 class="theme_color">
                            <strong>Upcoming Events</strong>
                        </h3>
                    </div>
                </div>

                <div class="row" *ngFor="let sfiev of eventDetails"
                    style="border-top: solid 1px gray;border-bottom: solid 1px gray;padding-top: 1%;padding-bottom: 1%;">
                    <div class="col-sm-8 col-sm-4">
                        <span class="maroonfont mediumFontSize"><strong>{{sfiev.eventname}}</strong></span>
                    </div>
                    <div class="col-sm-4 col-sm-4">
                        <span class="silver_font">{{sfiev.date}} ({{sfiev.time}})
                            {{sfiev.venue}}{{sfiev.IsEntryFull}}</span><br />

                        <a class="maroonfont" href="{{sfiev.link}}" target="_blank"
                            *ngIf="sfiev.isentryfull===false"><u><strong>Register
                                    Now</strong></u></a>

                        <a class="maroonfont" href="" data-toggle="modal" data-target="#exampleModal"
                            *ngIf="sfiev.isentryfull===true" (click)="getData(sfiev)"><u><strong>Join Wait
                                    List</strong></u></a>


                    </div>
                </div>

                <div class="row" *ngIf="eventDetails.length===0"
                    style="border-top: solid 1px gray;border-bottom: solid 1px gray;padding-top: 1%;padding-bottom: 1%;">
                    <div class="col-sm-12 col-sm-12">
                        <span class="maroonfont mediumFontSize"><strong>No Upcoming Events</strong></span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-left" data-aos-delay="300" style="background-color: #032d57;">
                <div style="margin:10%;" class="white_fonts">
                    <h3>
                        <strong>Online Training</strong>
                    </h3>
                    <p class="theme_color fontSize">
                        SFI Safety has partnered with ClickSafety, an OSHA-authorized online training provider,
                         to expand access to high-quality safety education. This partnership gives employees a flexible
                          option to complete important training when attending a live class is not practical.
                    </p>
                    <p class="theme_color fontSize">
                        Our online training options help organizations go Beyond Compliance by making safety education more accessible,
                         consistent, and convenient for today’s workforce.
                    </p>
                    <a class="btn" style="background-color: #962824;color: white;"
                        href="http://business.clicksafety.com/sficompliance" target="_blank">
                        Learn More
                    </a>
                </div>

            </div>

        </div>
        <div class="row" style="padding-top: 3%;">
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="300" style="padding-top: 20px;">
                <img src="../../assets/images/training room.JPG" class="img-fluid" alt="" /><br />
            </div>
            <div class="col-lg-8" data-aos="fade-left" data-aos-delay="300" style="padding-top: 20px;">
                <h1 class="theme_color">
                    <strong>We also offer room rentals!</strong>.
                </h1>

                <p class="theme_color fontSize">Need a space for your next corporate meeting? We offer our
                    training room for rent hourly or for the day. <strong><a href="/contact"
                            class="theme_color"><u>Contact us</u></a></strong> for more information or to get a
                    quote!</p>

                <p>Email us at <a href="mailto:customerservice@sfisafety">customerservice@sfisafety</a>
                    to schedule your next training today!</p>

            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" *ngIf="event!=null">{{event.eventname}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-12 entries" data-aos="fade-up" data-aos-delay="200">
                                <article class="entry entry-single">

                                    <h6>Help us to reach you out!</h6>
                                    <div class="row">
                                        <div class="col-md-12 mt-2">
                                            <input type="text" name="name" [(ngModel)]="name"
                                                class="form-control redborder" id="name" placeholder="Your Name"
                                                minlength="4" />
                                        </div>
                                    </div>                                    

                                    <div class="row">
                                        <div class="col-md-12 mt-2">
                                            <input type="text" name="email" [(ngModel)]="email"
                                                class="form-control redborder" id="email"
                                                placeholder="Your Email Address" minlength="10" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 mt-2">
                                            <input type="text" name="phone" [(ngModel)]="phone"
                                                class="form-control" id="phone" placeholder="Phone Number"
                                                minlength="7" />
                                        </div>
                                    </div>
                                </article>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" (click)="submitData()">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>